module.exports = __webpack_public_path__ + "static/media/map.2cb879d2.webp";